import type { CreateCampaignFlowValues } from "../forms/campaignFlowForm";
import type { BudgetData, BudgetPhaseForm } from "../components/GuidedBudgetEditor";

function coerceFormBudgetAmount(raw: unknown): number | null {
  if (raw == null) return null;
  const n = typeof raw === "number" ? raw : Number(String(raw).trim());
  return Number.isFinite(n) ? n : null;
}

function formBudgetType(
  values: CreateCampaignFlowValues
): "daily" | "lifetime" | "scheduled" {
  if (values.budget?.type === "daily") return "daily";
  if (values.budget?.type === "scheduled") return "scheduled";
  return "lifetime";
}

function buildSimpleBudgetDataForCreatePayload(
  values: CreateCampaignFlowValues,
  type: "daily" | "lifetime"
): BudgetData {
  const coerced = coerceFormBudgetAmount(values.budget?.amount?.amount);
  return {
    type,
    amount: {
      amount: coerced ?? 0,
      currency: values.budget?.amount?.currency ?? "USD",
    },
  };
}

function buildScheduledBudgetDataForCreatePayload(
  values: CreateCampaignFlowValues
): BudgetData {
  const currency =
    values.budget?.amount?.currency ??
    values.budget?.base?.amount?.currency ??
    "USD";
  return {
    type: "scheduled",
    amount: { amount: null, currency },
    base: {
      type: "lifetime",
      amount: { amount: null, currency },
    },
    segments: (values.budget?.segments ?? []).map(
      (s): BudgetPhaseForm => ({
        time_start: s.time_start ?? "",
        time_end: s.time_end ?? "",
        amount: {
          amount: coerceFormBudgetAmount(s.amount?.amount),
          currency: s.amount?.currency ?? currency,
        },
      })
    ),
  };
}

/**
 * `budget` slice for {@link GuidedCreateCampaignParams} from create-flow form values.
 * Each budget mode has its own builder; this function dispatches.
 */
export function buildBudgetDataForGuidedCreatePayload(
  values: CreateCampaignFlowValues
): BudgetData {
  const t = formBudgetType(values);
  if (t === "scheduled") {
    return buildScheduledBudgetDataForCreatePayload(values);
  }
  return buildSimpleBudgetDataForCreatePayload(values, t);
}
